import { AssignmentType } from '../types';
import { FieldProps, TextField, useFieldHelper } from 'framework/ui/field';

const PositionInAssignmentField = ({ source, ...props }: FieldProps) => {
  const { getValue: getAssignmentType } = useFieldHelper({ source });

  return getAssignmentType() === AssignmentType.INDIVIDUAL_ASSIGNMENT ? (
    <TextField source="position.name" {...props} />
  ) : (
    <TextField value="Public Service" {...props} />
  );
};

export default PositionInAssignmentField;
